import * as React from 'react';
import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

const InputComponent = forwardRef<HTMLInputElement, InputProps>(({ label, error, icon, className = '', ...props }, ref) => {
  return (
    <div className="w-full">
      {label && <label className="block text-[15px] font-medium text-gray-700 mb-2">{label}</label>}
      <div className="relative">
        {icon && <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400">{icon}</div>}
        <input
          ref={ref}
          className={`w-full h-10 px-3 bg-white border border-[#D1D5DB] rounded-md text-sm text-[#111827] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#FED7D5] focus:border-[#F67570] transition-all ${
            icon ? 'pl-10' : ''
          } ${error ? 'border-[#EF4444] focus:ring-[#FEE2E2] focus:border-[#EF4444]' : ''} ${className}`}
          {...props}
        />
      </div>
      {error && <p className="mt-1.5 text-[13px] text-[#DC2626]">{error}</p>}
    </div>
  );
});

InputComponent.displayName = 'Input';

export default InputComponent;
